import http from 'plugins/axios';

export default {
  getList(params) {
    return http.get({
      url: '/la/admin/site/conf/media/list',
      data: params
    });
  },
  addItem(data) {
    return http.post({
      url: '/la/admin/site/conf/media/add',
      data
    });
  },
  updateItem(data) {
    return http.post({
      url: '/la/admin/site/conf/media/update',
      data
    });
  },
  deleteItem({ mediaType, key }) {
    return http.post({
      url: `/la/admin/site/conf/media/del?mediaType=${encodeURIComponent(mediaType)}&key=${encodeURIComponent(key)}`
    });
  }
};
